import React from 'react';
import {Grid, Responsive, Segment, Button, Icon} from 'semantic-ui-react';
import { goToAnchor } from 'react-scrollable-anchor';

export default (props) => {
    return <Grid>
        <Grid.Row>
            <Grid.Column>
                <Segment basic clearing style={{padding: 0}}>
                    <Responsive maxWidth={600}>
                        <Segment clearing basic style={{padding: 0}}>
                            <Button style={{borderRadius: 0,}} floated='left' color="grey" onClick={() => window.open(props.lang.form_container[`${props.selectedChallenge}_pdf`])}>
                                <Icon name="file pdf" />
                                {props.lang.form_container.download_button_label}
                            </Button>
                            
                        </Segment>
                        <Segment clearing basic style={{padding: 0}}>
                            <Button style={{borderRadius: 0}} floated='left' positive onClick={() => props.isChecked? window.open(props.lang[`${props.selectedChallenge}_link`]) : alert(props.lang.form_container.not_checked_alert)}>
                                <Icon name="user plus" />
                                {props.lang.form_container.submit_button_label}
                            </Button>
                        </Segment>
                        <Segment clearing basic style={{padding: 0}}>
                            <Button style={{borderRadius: 0}} floated='left' negative onClick={() => goToAnchor("home", false)}>
                                <Icon name="arrow up" />
                                {props.lang.form_container.back_to_top_button_label}
                            </Button>
                        </Segment>
                    </Responsive>
                    <Responsive minWidth={601}>
                        <Segment clearing basic style={{padding: 0}}>
                            <Button style={{borderRadius: 0}} floated='left' negative onClick={() => goToAnchor("home", false)}>
                                <Icon name="arrow up" />
                                {props.lang.form_container.back_to_top_button_label}
                            </Button>
                            <Button style={{borderRadius: 0, marginLeft: "1rem"}} floated='left' color="grey" onClick={() => window.open(props.lang.form_container[`${props.selectedChallenge}_pdf`])}>
                                <Icon name="file pdf" />
                                {props.lang.form_container.download_button_label}
                            </Button>
                            <Button style={{borderRadius: 0}} floated='right' positive onClick={() => props.isChecked? window.open(props.lang[`${props.selectedChallenge}_link`]) : alert(props.lang.form_container.not_checked_alert)} disabled>
                                <Icon name="user plus" />
                                {props.lang.form_container.submit_button_label}
                            </Button>
                        </Segment>
                    </Responsive>
                </Segment>
            </Grid.Column>
        </Grid.Row>
    </Grid>
}


// WEBPACK FOOTER //
// ./src/components/formButton/FormButtonContainer.jsx